<script setup>
import {Menu, MenuButton, MenuItems, MenuItem} from '@headlessui/vue'
import {Icon} from "@iconify/vue";
import {useMainOrdersStore} from "@/stores/mainOrders.js";
import {formatPrice} from "@/utils/priceFormatter.js";

const ordersStore = useMainOrdersStore();
</script>
<template>
  <div class="text-right">
    <Menu as="div" class="relative inline-block text-left">
      <div>
        <MenuButton
            class="btn btn-outline-dark inline-flex w-full justify-center rounded-md bg-black/20 px-4 py-2 text-xs font-medium text-white hover:bg-black/30 gap-2 items-center h-[32px]"
        >
          Summary
          <Icon icon="radix-icons:caret-down"/>
        </MenuButton>
      </div>

      <transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0"
      >
        <MenuItems class="absolute right-0 mt-2 min-w-72 origin-top-right rounded-lg bg-slate-800 z-10 shadow-2xl border border-slate-600">
          <div class="p-3">
            <MenuItem v-slot="{ active }">
              <div class="flex flex-row justify-between w-full group p-2 text-sm rounded-md gap-4"
                   :class="active ? 'bg-slate-700/20 text-slate-100' : 'text-slate-200'">
                <p>Amount:</p>
                <p>{{ formatPrice(ordersStore.getSummary('currencyBuy', 'CurrencyBuy', 'CurrencyBuy').amount) }}</p>
              </div>
            </MenuItem>
            <MenuItem v-slot="{ active }">
              <div class="flex flex-row justify-between w-full group p-2 text-sm rounded-md gap-4"
                   :class="active ? 'bg-slate-700/20 text-slate-100' : 'text-slate-200'">
                <p>Value:</p>
                <p>{{ formatPrice(ordersStore.getSummary('currencyBuy', 'CurrencyBuy', 'CurrencyBuy').value) }} $</p>
              </div>
            </MenuItem>
            <MenuItem v-slot="{ active }">
              <div class="flex flex-row justify-between w-full group p-2 text-sm rounded-md gap-4"
                   :class="active ? 'bg-slate-700/20 text-slate-100' : 'text-slate-200'">
                <p>Toman Value:</p>
                <p>{{ formatPrice(ordersStore.getSummary('currencyBuy', 'CurrencyBuy', 'CurrencyBuy').tomanValue) }} Tmn</p>
              </div>
            </MenuItem>
            <MenuItem v-slot="{ active }">
              <div class="flex flex-row justify-between w-full group p-2 text-sm rounded-md gap-4"
                   :class="active ? 'bg-slate-700/20 text-slate-100' : 'text-slate-200'">
                <p>Records:</p>
                <p>{{ formatPrice(ordersStore.getSummary('currencyBuy', 'CurrencyBuy', 'CurrencyBuy').records) }}</p>
              </div>
            </MenuItem>
          </div>
        </MenuItems>
      </transition>
    </Menu>
  </div>
</template>


